import React from 'react';
import styled from 'styled-components';
import { CloudfrontImage } from "../CloudfrontAsset";

function Magnetic({ onClick }) {
    const Wrapper = styled.div`
        width: 100%;
        height: 160px;
        position: relative;
        background-color: white;
        
        
        margin-top: 8px;
        
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        
        cursor: pointer;
    `

    const ImgWrapper = styled.div`
        max-width: 360px;
        width: 100%;
        height: auto;
        position: relative;
        
        display: block;
        margin: 0 auto;
    `

    const MagneticImg = styled(CloudfrontImage)`
        position: absolute;
        top: 15px;
        left: 15px;
    `

    const BackgroundImg = styled(CloudfrontImage)`
        width: 100%;
        height: 100%;
    `

    return (
        <Wrapper onClick={onClick}>
            <ImgWrapper>
                <MagneticImg
                    src={'https://d15eixcc3515pq.cloudfront.net/Assets/img/img-magnetic.png'}
                    logContext={{ component: 'Magnetic', assetType: 'magnetic' }}
                />
                <BackgroundImg
                    src={'https://d15eixcc3515pq.cloudfront.net/Assets/img/group-2.png'}
                    logContext={{ component: 'Magnetic', assetType: 'background' }}
                />
            </ImgWrapper>
        </Wrapper>
    )
}


export default Magnetic;
